import domready from "domready";

let cookieName: string = "feedbackClosed";
let waitPageViews: number = 3;
let waitSeconds: number = 10;


function localStorageAvailable() {
    try {
        return localStorage ? true : false;
    }
    catch(e) {
        return false;
    }
}

function setCookie(name: string, val: string) {
    const date = new Date();
    const value = val;
    date.setTime(date.getTime() + (14 * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length == 2) {
        return parts.pop()?.split(";").shift();
    }
    return "";
}

function feedbackCookieIsSet() {
    try {
        return getCookie(cookieName) === "true";
    }
    catch {
        return false;
    }
}

function closeFeedback() {
    setCookie(cookieName, "true");
    document.getElementById("feedback-popup")?.classList.remove("on");
}


domready(() => {
    let feedback = document.getElementById("feedback-popup");
    let feedbackFormLink = document.getElementById("feedback-form-link");
    let feedbackFormClose = document.getElementById("feedback-close");
    let reservationDialog = document.getElementById("reservation-dialog");

    if (!feedback || feedbackCookieIsSet())
        return;

    feedbackFormLink?.addEventListener("click", () => { closeFeedback() });
    feedbackFormClose?.addEventListener("click", () => { closeFeedback() });

    if (localStorageAvailable()) {
        let pageViews : number = Number(localStorage.getItem("feedbackPageCount") ?? 0);
        pageViews += 1;
        localStorage.setItem("feedbackPageCount", pageViews.toString());

        if (pageViews > waitPageViews)
        {
            setTimeout(() => {
                if (!reservationDialog?.innerHTML)
                    feedback?.classList.toggle("on")
                }, waitSeconds * 1000 
            );
        }
    }
});